import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">주식회사 애드플러스디벨롭먼트</h1>
          <p className="hero-subtitle">AdPlus Development Co., Ltd.</p>
        </div>
      </section>
      
      <section className="main-section">
        <div className="container">
          <div className="content-placeholder">
            <h2>[상세내용 추가중입니다.]</h2>
            <p>안녕하세요. 주식회사 애드플러스디벨롭먼트입니다.</p>
            <p>상세 내용은 현재 추가중입니다.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;